import { ROLES } from "./roles";

export const menuByRole = {

    [ROLES.SELLER]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },

        {
            path: "/instant-request",
            icon: "fas fa-bolt",
            label: "Instant Request",
            section: "pages"
        },
        {
            path: "/my-offers",
            icon: "fas fa-percent",
            label: "My Offers",
            section: "pages"
        },

        {
            label: "Orders",
            icon: "fas fa-shopping-cart",
            section: "pages",
            path: "/orders",
            // children: [
            //     { path: "/orders", label: "My Orders" },
            //     { path: "/orders/pending", label: "Pending Orders" },
            //     { path: "/orders/completed", label: "Completed Orders" }
            // ]
        },

        // {
        //     path: "/inventory",
        //     icon: "fas fa-warehouse",
        //     label: "Inventory",
        //     section: "pages"
        // },

        // {
        //     path: "/shipments",
        //     icon: "fas fa-truck",
        //     label: "Shipments",
        //     section: "pages"
        // }
    ],

    [ROLES.BUYER]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },

        {
            path: "/search-material",
            icon: "fas fa-search",
            label: "Search Material",
            section: "pages"
        },

        {
            path: "/orders",
            icon: "fas fa-shopping-cart",
            label: "Orders",
            section: "pages"
        }
    ],

    [ROLES.FREIGHT]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },

        {
            path: "/shipments",
            icon: "fas fa-truck",
            label: "Active Shipments",
            section: "pages"
        },

        {
            path: "/my-trucks",
            icon: "fas fa-truck-loading",
            label: "My Trucks",
            section: "pages"
        }
    ],

    [ROLES.ADMIN]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },
        {
            label: "Freight",
            icon: "fas fa-truck-fast",
            section: "pages",
            path: "/freight",
            children: [
                { path: "/freight/new_users", label: "New Users" },
                { path: "/freight/active_users", label: "Active Users" },
                { path: "/freight/inactive_users", label: "Inactive Users" },
                { path: "/freight/orders", label: "Orders" },
                { path: "/freight/rm_chats", label: "RM Chats" },
                { path: "/freight/form_request", label: "Freight Form Request" },
                { path: "/freight/faqs", label: "FAQs" },
                { path: "/freight/faq_section", label: "FAQ Section" },
                { path: "/freight/account_under_review", label: "Account Under Review Page Slider" },
                { path: "/freight/profile_status", label: "Profile Status" },
                { path: "/freight/order_status", label: "Order Status" },
                { path: "/freight/vehicle_capacities", label: "Vehicle Capacities" },
                { path: "/freight/service_categories", label: "Service Categories" },
                { path: "/freight/social_media", label: "Social Media" },
                { path: "/freight/app_drawer", label: "App Drawer" },
            ]  
        },

        {
            path: "/team-management",
            icon: "fas fa-users",
            label: "Team Management",
            section: "pages"
        },

        {
            path: "/account",
            icon: "fas fa-user-cog",
            label: "Admin Account",
            section: "pages"
        }
    ]

};